/**
 * 获取鼠标在拖拽容器的位置，前一个/后一个/内部
 * @param relativeInfo
 * @param containerEl
 */
export const PREV_NEXT_INNER = {
  prev: 'prev',
  next: 'next',
  inner: 'inner',
  moving: 'moving'
}

// 挂载在元素节点上
export const DROP_LAYOUT_EL = 'drop_layout_el'

// 拖拽激活容器的类名
export const DROP_CONTAINER_ACTIVE_CLASSNAME = {
  [PREV_NEXT_INNER.prev]: 'drop-container-active-prev',
  [PREV_NEXT_INNER.next]: 'drop-container-active-next',
  [PREV_NEXT_INNER.inner]: 'drop-container-active-inner',
  [PREV_NEXT_INNER.moving]: 'drop-element-is-moving'
}

// 当前正在缩放的元素的最小尺寸
export const MIN_SCALE_SIZE = 10

// 辅助线出现的最大距离
export const HELP_LINE_LENGTH = 5

// 事件名
export const EVENT_NAME_LIST = [
  'onKeydown', 'onKeyup','onMousedown', 'onMouseup', 'onMousemove',"onBlur","onOpen","onEdit","onLoad","onClose","onFocus","onInput","onClick","onPress","onScale","onCancel","onClosed","onChange","onDelete","onOpened","onScroll","onSubmit","onSelect","onToggle","onConfirm","onPreview","onKeypress","onTouchend","onClickStep","onTouchmove","onTouchstart","onTouchcancel","onSelectSearch",
]
// HTML5标签名：https://www.cnblogs.com/susanws/p/5387594.html
export const LABEL_NAME_LIST = [
  'a',         //	定义超链接
  'abbr',          //	定义缩写
  'acronym',         //	HTML5中不支持，定义首字母缩写
  'address',         //	定义地址元素
  'applet',          //	HTML5中不支持，定义applet
  'area',          //	定义图像映射中的区域
  'article',         //	定义 article
  'aside',         //	定义页面内容之外的内容
  'audio',         //	定义声音内容
  'b',         //	定义粗体文本
  'base',          //	定义页面中所有链接的基准URL
  'basefont',          //	HTML5中不支持，请使用CSS代替
  'bdi',         //	定义文本的文本方向，使其脱离其周围文本的方向设置
  'bdo',         //	定义文本显示的方向
  'big',         //	HTML5中不支持，定义大号文本
  'blockquote',          //	定义长的引用
  'body',          //	定义body元素
  'br',          //	插入换行符
  'button',          //	定义按钮
  'canvas',          //	定义图形
  'caption',         //	定义表格标题
  'center',          //	HTML5中不支持，定义居中的文本
  'cite',          //	定义引用
  'code',          //	定义计算机代码文本
  'col',         //	定义表格列的属性
  'colgroup',          //	定义表格列的分组
  'command',         //	定义命令按钮
  'datalist',          //	定义下拉列表
  'dd',          //	定义定义的描述
  'del',         //	定义删除文本
  'details',         //	定义元素的细节
  'dfn',         //	定义定义项目
  'dir',         //	HTML5中不支持，定义目录列表
  'div',         //	定义文档中的一个部分
  'dl',          //	定义定义列表
  'dt',          //	定义定义的项目
  'em',          //	定义强调文本
  'embed',         //	定义外部交互内容或插件
  'fieldset',          //	定义fieldset
  'figcaption',          //	定义figure元素的标题
  'figure',          //	定义媒介内容的分组，以及它们的标题
  'font',          //	HTML5中不支持
  'footer',          //	定义section或page的页脚
  'form',          //	定义表单
  'frame',         //	HTML5中不支持，定义子窗口（框架）
  'frameset',          //	HTML5中不支持，定义框架的集
  'h1',          // to 'h6',          //	定义标题 1 到标题 6
  'h2',          // to 'h6',          //	定义标题 1 到标题 6
  'h3',          // to 'h6',          //	定义标题 1 到标题 6
  'h4',          // to 'h6',          //	定义标题 1 到标题 6
  'h5',          // to 'h6',          //	定义标题 1 到标题 6
  'h6',          // to 'h6',          //	定义标题 1 到标题 6
  'head',          //	定义关于文档的信息
  'header',          //	定义section或page的页眉
  'hgroup',          //	定义有关文档中的 section 的信息
  'hr',          //	定义水平线
  'html',          //	定义 html 文档
  'i',         //	定义斜体文本
  'iframe',          //	定义行内的子窗口（框架）
  'img',         //	定义图像
  'input',         //	定义输入域
  'ins',         //	定义插入文本
  'keygen',          //	定义生成密钥
  'isindex',         //	HTML5中不支持，定义单行的输入域
  'kbd',         //	定义键盘文本
  'label',         //	定义表单控件的标注
  'legend',          //	定义 fieldset 中的标题
  'li',          //	定义列表的项目
  'link',          //	定义资源引用
  'map',         //	定义图像映射
  'mark',          //	定义有记号的文本
  'menu',          //	定义菜单列表
  'meta',          //	定义元信息
  'meter',         //	定义预定义范围内的度量
  'nav',         //	定义导航链接
  'noframes',          //	HTML5中不支持，定义noframe部分
  'noscript',          //	定义 noscript 部分
  'object',          //	定义嵌入对象
  'ol',          //	定义有序列表
  'optgroup',          //	定义选项组
  'option',          //	定义下拉列表中的选项
  'output',          //	定义输出的一些类型
  'p',         //	定义段落
  'param',         //	为对象定义参数
  'pre',         //	定义预格式化文本
  'progress',          //	定义任何类型的任务的进度
  'q',         //	定义短的引用
  'rp',          //	定义若浏览器不支持 ruby 元素显示的内容
  'rt',          //	定义 ruby 注释的解释
  'ruby',          //	定义 ruby 注释
  's',         //	HTML5中不支持，定义加删除线的文本
  'samp',          //	定义样本计算机代码
  'script',          //	定义脚本
  'section',         //	定义section
  'select',          //	定义可选列表
  'small',         //	将旁注 (side comments) 呈现为小型文本
  'source',          //	定义媒介源
  'span',          //	定义文档中的 section
  'strike',          //	HTML5中不支持，定义加删除线的文本
  'strong',          //	定义强调文本
  'style',         //	定义样式定义
  'sub',         //	定义下标文本
  'summary',         //	定义details元素的标题
  'sup',         //	定义上标文本
  'table',         //	定义表格
  'tbody',         //	定义表格的主体
  'td',          //	定义表格单元
  'textarea',          //	定义textarea
  'tfoot',         //	定义表格的脚注
  'th',          //	定义表头
  'thead',         //	定义表头
  'time',          //	定义日期/时间
  'title',         //	定义文档的标题
  'tr',          //	定义表格行
  'track',         //	定义用在媒体播放器中的文本轨道
  'tt',          //	HTML5中不支持，定义打字机文本
  'u',         //	HTML5中不支持，定义下划线文本
  'ul',          //	定义无序列表
  'var',         //	定义变量
  'video',         //	定义视频
  'xmp',         //	HTML5中不支持，定义预格式文本
]